export const SupportFAQ = [
  {
    question: ' Do I need a credit card to sign up?',
    answer: 'No, it\'s completely free to sign up! You can start using NeoFace without providing any payment information.'
  },
  {
    question: 'How is my data kept private?',
    answer: 'At NeoFace, we prioritize the security and privacy of your data. We employ industry-standard security practices, including encryption and secure storage, to ensure that your information is kept safe. Your data is never shared with third parties, ever.'
  },
  {
    question: 'Can I use NeoFace for both SFW and NSFW content?',
    answer: 'Absolutely! NeoFace caters to a diverse audience and supports content creators across both SFW and NSFW domains. Our face anonymization technology allows you to engage with your audience while maintaining your privacy, regardless of the nature of your content.'
  },
  {
    question: 'How long does a swap take to process?',
    answer: 'For images, a swap typically takes less than 10 seconds. For videos, the time taken depends on the length of the video. For a 1-minute video, the swap can take up to 15-20 minutes. We are constantly working to improve the speed of our swaps, so stay tuned for updates! Also, make sure to turn on notifications to know when your video swap is ready.'
  },
]